"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_dev_1 = require("./is-dev");
var getMap = function (config) { return ({
    setMapTypeId: function (val) { return val; },
    mapTypes: {
        set: function (val) { return val; }
    },
    setCenter: function (val) { return val; }
}); };
var googlePolyfill = {
    maps: {
        StyledMapType: function (val) { return val; },
        Map: function (config) { return getMap(config); },
        Marker: function () { return ({
            setPosition: function (val) { return val; }
        }); }
    }
};
exports.default = is_dev_1.isDevEnv() ? googlePolyfill : window['google'] || googlePolyfill;
